import { render, staticRenderFns } from "./yuerblinxi.vue?vue&type=template&id=3456de01&scoped=true&"
import script from "./yuerblinxi.vue?vue&type=script&lang=js&"
export * from "./yuerblinxi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456de01",
  null
  
)

export default component.exports